<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
    <v-card>      

      <v-card-title class="title-modal">
        <span class="headline">{{ title }}</span>
      </v-card-title>

      <v-card-text>
        <!-- v-chips con los shipment_ids -->
        
        <p>
            Crear ola de preparación con las órdenes {{ shipments.length }} de envío seleccionadas
        </p>
        <v-form ref="form">
          <v-combobox v-model="item.almacen" name="name" item-title="name" item-value="id" :items="almacenes"
            label="Almacen*" autocomplete="off" :rules="[rules.requiredComboBox]" clearable
            @update:modelValue="
              () => {
                this.loadMuelles();                          
              }
            "
          ></v-combobox>

          <v-combobox 
          v-model="item.dock" name="name" item-title="name" item-value="id" :items="muelles" :disabled="!item.almacen"
            label="Muelle*" autocomplete="off" 
            :rules="[rules.requiredComboBox]" 
            clearable></v-combobox>

          <v-textarea v-model="item.description" name="description" label="Descripción" scrollable></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="$emit('updateDialog')"> Cancelar </v-btn>
        <v-btn color="green" text @click="create()" :loading="loading"> Crear </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { muelleService } from "@/libs/ws/muelleService";
import { almacenService } from "@/libs/ws/almacenService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  created() { },
  mixins: [ValidMixin],
  components: {},
  props: {
    dialog: Boolean,
    updateDialog: Function,
    createPreparationWave: Function,
    loading: Boolean,
    shipments: Array,
    title: String,
    toast: Object
  },
  data: () => ({
    item: {
      dock: null,
      shipment_orders: [],
      description: null,
      almacen: null,
    },
    defaultItem: null,    
    muelles: [],    
    almacenes: [],
  }),
  watch: {
    dialog(val) {
      if (!val) {
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
      }
    },
  },
  mounted() {
    this.item.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.loadAlmacenes();
    if(this.item.almacen){
      this.loadMuelles();
    }
  },
  methods: {
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          // console.log("almacenes",response);
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadMuelles() {
        this.loading_muelles = true;        
        muelleService
            .filter({ almacen: this.almacen })
            .then((response) => {
                this.muelles = response.result.list;
            })
            .catch((e) => {
                console.log("service.load error");
                console.log(e);
            })
            .finally(() => {
                this.loading_muelles = false;
            });
    },
    create() { 
      if(this.loading) return;
      //Validar form
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.$emit("createPreparationWave", this.item);
        }else{
          console.log("error", this.$refs.form.errors);
          this.toast.error("Por favor, complete los campos requeridos");
        }
      });      
    }   
  },
};
</script>